if (!window.Eurus.loadedScript.includes('sticky-atc.js')) {
  window.Eurus.loadedScript.push('sticky-atc.js');

  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      const findHtmlElement = (html, id) => {
        if (!html || !id) return null;
        const direct = html.getElementById?.(id);
        if (direct) return direct;
        const templates = html.querySelectorAll?.('template');
        if (!templates?.length) return null;
        for (const tpl of templates) {
          const found = tpl.content?.getElementById?.(id);
          if (found) return found;
        }
        return null;
      };

      Alpine.data('xStickyATC', (sectionId, is_combined) => ({
        openDetailOnMobile: false,
        showStickyATC: typeof window.matchMedia === 'function'
          ? window.matchMedia('(max-width: 767px)').matches
          : true,
        currentAvailableOptions: [],
        options: [],
        init() {
          if (!is_combined) {
            this.variants = xParseJSON(this.$el.getAttribute('x-variants-data'));
          }

          this.guardMobileQuantityFocus();
          this.$nextTick(() => this.bindStickyVisibility(sectionId));

          document.addEventListener(`eurus:product-page-variant-select:updated:${sectionId}`, (e) => {
            if (is_combined) {
              this.renderVariant(e.detail.html);
            } else {
              this.currentAvailableOptions = e.detail.currentAvailableOptions,
              this.options = e.detail.options;
            }

            this.renderProductPrice(e.detail.html);
            this.renderMedia(e.detail.html);
            this.renderVariantTitle(e.detail.html);
          });
        },
        bindStickyVisibility(sectionId) {
          const isDesktop = () => typeof window.matchMedia === 'function'
            && window.matchMedia('(min-width: 768px)').matches;

          let footerVisible = false;
          let mainAtcVisible = isDesktop();

          const update = () => {
            if (footerVisible) {
              this.showStickyATC = false;
              return;
            }
            this.showStickyATC = isDesktop() ? !mainAtcVisible : true;
          };

          if ('IntersectionObserver' in window) {
            const footer = document.querySelector('.section-footer');
            if (footer) {
              new IntersectionObserver((entries) => {
                if (!entries.length) return;
                footerVisible = entries[0].isIntersecting;
                update();
              }, { threshold: 0 }).observe(footer);
            }

            const mainAtc = document.getElementById('x-atc-button-' + sectionId)
              || document.querySelector('.x-product-' + sectionId + ' .x-qty-atc-row')
              || document.querySelector('.x-product-' + sectionId + ' .x-block-buy-buttons');
            if (mainAtc) {
              new IntersectionObserver((entries) => {
                if (!entries.length) return;
                mainAtcVisible = entries[0].isIntersecting;
                update();
              }, { threshold: 0 }).observe(mainAtc);
            }
          }

          window.addEventListener('resize', update);
          update();
        },
        guardMobileQuantityFocus() {
          const bar = this.$el;
          if (!bar) return;

          const blurStickyQty = () => {
            const qtyInput = bar.querySelector('input[name="quantity"]');
            if (qtyInput && document.activeElement === qtyInput) {
              qtyInput.blur();
            }
          };

          blurStickyQty();
          this.$nextTick(blurStickyQty);
          requestAnimationFrame(blurStickyQty);
          [50, 200, 400].forEach((ms) => setTimeout(blurStickyQty, ms));

          if (typeof window.matchMedia === 'function' && window.matchMedia('(max-width: 767px)').matches) {
            const qtyWrap = bar.querySelector('.x-sticky-qty') || bar.querySelector('.quantity-selector-container');
            if (qtyWrap) {
              qtyWrap.classList.add('pointer-events-none');
              setTimeout(() => qtyWrap.classList.remove('pointer-events-none'), 350);
            }
          }
        },
        renderProductPrice(html) {
          const destinations = document.querySelectorAll(`.price-sticky-${sectionId}`);
          if (!destinations.length) return;

          const source = findHtmlElement(html, 'price-sticky-' + sectionId)
            || document.getElementById('price-' + sectionId);

          destinations.forEach((destination) => {
            if (source) destination.innerHTML = source.innerHTML;
          });
        },
        renderMedia(html) {
          const destination = document.getElementById('product-image-sticky-' + sectionId);
          const source = findHtmlElement(html, 'product-image-sticky-' + sectionId);
  
          if (source && destination) destination.innerHTML = source.innerHTML;
        },
        renderVariantTitle(html) {
          const destinations = document.querySelectorAll(`.variant-title-sticky-${sectionId}`);
          if (!destinations.length) return;

          destinations.forEach((destination) => {
            const source = findHtmlElement(html, 'variant-title-sticky-' + sectionId);
            if (source) {
              destination.innerHTML = source.innerHTML;
              return;
            }

            if (Array.isArray(this.options) && this.options.length) {
              destination.textContent = this.options.filter(Boolean).join(' / ');
            }
          });
        },
        renderVariant(html) {
          const destination = document.getElementById('variant-update-sticky-' + sectionId);
          const source = findHtmlElement(html, 'variant-update-sticky-' + sectionId);
  
          if (source && destination) destination.innerHTML = source.innerHTML;
        },
        changeOptionSticky(event) {
          Array.from(event.target.options)
            .find((option) => option.getAttribute('selected'))
            .removeAttribute('selected');
          event.target.selectedOptions[0].setAttribute('selected', 'selected');
          const input = event.target.selectedOptions[0];
          const inputId = input.id;
          const targetUrl = input.dataset.productUrl;
          const variantEl = document.getElementById('variant-update-sticky-' + sectionId);
          document.dispatchEvent(new CustomEvent(`eurus:product-page-variant-select-sticky:updated:${sectionId}`, {
            detail: {
              inputId: inputId,
              targetUrl: targetUrl,
              variantElSticky: variantEl
            }
          }));
        }
      }))
    })
  })
}
